"use client"
import React, { useState, useEffect, useCallback } from "react"
import Image from "next/image"
import { useTranslation } from "react-i18next"
import { useRouter } from "next/navigation"
import { motion } from "framer-motion"
import { ArrowRight } from "lucide-react"
import { trackEvent } from "../lib/analytics"

const Hero = React.forwardRef((props, ref) => {
  const [mounted, setMounted] = useState(false)
  const { t } = useTranslation()
  const router = useRouter()

  useEffect(() => {
    setMounted(true)
  }, [])

  const handleTryRoset = useCallback((e) => {
    e.preventDefault()
    trackEvent("cta_click", { location: "creator_story" })
    router.push("/app")
  }, [router])

  return (
    <section
      className="relative bg-slate-950 py-20 px-4 overflow-hidden"
      ref={ref}
    >
      <div className="absolute inset-0">
        <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-blue-600/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-5xl mx-auto relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row items-center gap-12"
        >
          <div className="shrink-0">
            <Image
              src="/images/profile.png"
              alt="Matias Quenardelle, creator of Roset"
              width={200}
              height={200}
              className="rounded-full object-cover object-top w-[180px] h-[180px] md:w-[200px] md:h-[200px] border-2 border-slate-800"
            />
          </div>
          <div className="text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 tracking-tight">
              {mounted ? t("HeroSection:hero.title") : "Hi, I'm Matias — I built Roset because I needed it myself"}
            </h2>
            <p className="text-slate-400 leading-relaxed mb-6 max-w-lg">
              {mounted ? t("HeroSection:hero.subtitle") : "Practicing German with Roset improved my vocabulary and pronunciation so much that I landed job offers in Switzerland and Germany. I built this app so you can have the same experience."}
            </p>
            <button
              onClick={handleTryRoset}
              className="group inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold px-7 py-3 rounded-full transition duration-200 hover:shadow-lg hover:shadow-blue-600/25"
            >
              {mounted ? t("HeroSection:hero.projectsButton") : "Start Speaking Free"}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-200" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  )
})

Hero.displayName = "Hero"

export default Hero
